import { PeriodSchema } from '@weft/types';
import { oz } from '@weft/utils';

export const GenerateMeasurementsDataSchema = oz.object({
  data: oz.object({
    period: PeriodSchema,
    customersIds: oz.array(oz.string().nonempty()).min(1),
    metersIds: oz.array(oz.string().nonempty()).min(1),
    minimumQuantity: oz.number().default(1),
    maximumQuantity: oz.number().default(10),
  }).refine(data => (data.maximumQuantity > data.minimumQuantity), {
    message: 'minimum quantity must be less than the maximum quantity',
    path: ['quantityMin'],
  }),
}).openapi('GenerateMeasurements');

export type GenerateMeasurementsData = oz.infer<typeof GenerateMeasurementsDataSchema>;